import React, { useState, useEffect } from 'react'
import { Modal, Button, Table, Pagination, Typography } from 'antd'
import styled from 'styled-components'
import { SignTitle, IconFont, DeleteModal, ConfirmInput } from '@/components'
import { ShowTotal } from '@/components/show-total'
import { Message } from '@/components/message'
import { t } from '@/i18n'
import {
  useGetLogsRecord,
  useLogsDelete,
  useLogsCollectStop,
  useLogsDownload,
  useLogsRetention,
} from '../util'

interface EditRemarks {
  visible: boolean
}

export const LogDownload = props => {
  const { showLog, setShowLog, updateClient } = props
  const [deleteLog] = useLogsDelete()
  // const [getLogList, logList] = useGetLogList()
  const [list, setList] = useState([])
  const [editRemark, setEditRemark] = useState<EditRemarks>({ visible: false })
  const [deleteModal, setDeleteModal] = useState({ visible: false, id: null })
  const [pageParams, setPageParams] = useState({ limit: 10, page: 1 })
  const [getLogsRecord, logList] = useGetLogsRecord()
  const [logsCollectStop] = useLogsCollectStop()
  const [logsDownload] = useLogsDownload()
  const [logsRetention] = useLogsRetention()

  useEffect(() => {
    if (showLog.visible) {
      getLogsRecord({ ...pageParams, agent_id: showLog.id }).catch(() => {})
    }
  }, [pageParams, showLog.visible])
  const Remark = values => {
    const {
      id,
      name,
      onOk,
      alias,
      onCancel,
      upAlias,
      type,
      unit,
      min = null,
      max = null,
      placeholder,
    } = values

    if (editRemark.visible) {
      return (
        <ConfirmInput
          placeholder={placeholder}
          name={name}
          title={''}
          id={id}
          onOk={onOk}
          onCancel={onCancel}
          type={type}
          min={min}
          max={max}
          unit={unit}
          style={{ marginRight: '5px' }}
        />
      )
    } else {
      return (
        <Typography.Text
          style={{
            fontSize: '14px',
            flex: 1,
          }}
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
        >
          <span style={{ color: 'rgb(32, 144, 168)', marginRight: 2 }}>{name}</span>
          {t('天')}
        </Typography.Text>
      )
    }
  }
  const columns = [
    {
      title: t('收集开始时间'),
      dataIndex: 'create_time',
    },
    {
      title: t('收集结束时间'),
      dataIndex: 'end_time',
    },
    {
      title: t('操作'),
      key: 'action',
      width: '150px',
      render: (_, record) => (
        <div className="operate">
          {!record.end_time ? (
            <div
              style={{ color: '#1b2b53', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => {
                logsCollectStop({ agent_id: showLog.id, log_id: record.id })
                  .then(() => {
                    getLogsRecord({ ...pageParams, agent_id: showLog.id }).catch(() => {})
                    updateClient()
                  })
                  .catch(() => {})
              }}
            >
              <IconFont style={{ fontSize: 16, marginRight: 6 }} type="icon-zanting2" />
              <span>{t('停用')}</span>
            </div>
          ) : (
            <>
              <div
                style={{
                  color: '#1b2b53',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  logsDownload({ agent_id: showLog.id, log_id: record.id })
                    .then(res => {
                      // 检查 res.data 是否是 Blob 对象
                      let blob: Blob
                      if (res.data instanceof Blob) {
                        blob = res.data
                      } else if (
                        res.data &&
                        typeof res.data === 'object' &&
                        Object.keys(res.data).length > 0
                      ) {
                        // 如果 res.data 是对象但不是空对象，尝试转换为 Blob
                        blob = new Blob([JSON.stringify(res.data)], { type: 'application/zip' })
                      } else {
                        // 如果 res.data 是空对象或其他情况，说明文件数据可能有问题
                        Message.error(t('下载失败：文件数据为空'))
                        return
                      }

                      // 从响应头提取文件名
                      const contentDisposition =
                        res.headers?.['content-disposition'] ||
                        res.headers?.['Content-Disposition'] ||
                        ''
                      let filename = t('运行日志.zip')
                      if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(
                          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        )
                        if (filenameMatch && filenameMatch[1]) {
                          filename = filenameMatch[1].replace(/['"]/g, '')
                          // 处理 UTF-8 编码的文件名
                          if (filename.startsWith("UTF-8''")) {
                            filename = decodeURIComponent(filename.replace(/^UTF-8''/, ''))
                          }
                        }
                      }

                      const url = window.URL.createObjectURL(blob)
                      const aLink = document.createElement('a')
                      aLink.style.display = 'none'
                      aLink.href = url
                      aLink.download = filename
                      document.body?.appendChild(aLink)
                      aLink.click()
                      window.URL.revokeObjectURL(url)
                      document.body?.removeChild(aLink)
                      Message.success(t('下载成功'))
                    })
                    .catch(err => {
                      console.error('下载失败：', err)
                      Message.error(err?.msg || t('下载失败'))
                    })
                }}
              >
                <IconFont style={{ color: '#1b2b53', marginRight: 6 }} type="icon-xiazai2" />
                <span>{t('下载')}</span>
              </div>
              <div
                style={{
                  color: '#1b2b53',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  marginLeft: 15,
                }}
                onClick={() => {
                  console.log(record)
                  deleteLog({ log_id: record.id })
                    .then(() => {
                      getLogsRecord({ ...pageParams, agent_id: showLog.id }).catch(() => {})
                    })
                    .catch(() => {})
                }}
              >
                <IconFont style={{ color: '#1b2b53', marginRight: 6 }} type="icon-shanchu-m" />
                <span>{t('删除')}</span>
              </div>
            </>
          )}
        </div>
      ),
    },
  ]
  return (
    <LogModal
      centered
      width={700}
      title={
        <SignTitle show>
          <>
            {t('运行日志下载')}
            <span style={{ marginLeft: 15, color: '#666', fontSize: 14 }}>
              {t('日志存储时间：')}
            </span>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                marginLeft: 6,
                color: '#666',
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              <Remark
                type="inputNumber"
                placeholder="1-180"
                name={logList?.retention_time || 30}
                min={1}
                max={180}
                unit={t('天')}
                onOk={async value => {
                  console.log('vaule', value)
                  try {
                    if (value > 180 || value < 1) {
                      Message.error('')
                      return
                    }
                    await logsRetention({
                      retention_time: value,
                      agent_id: showLog.id,
                    })
                    getLogsRecord({ ...pageParams, agent_id: showLog.id }).catch(() => {})
                    setEditRemark({ visible: false })
                  } catch (err) {}
                }}
                onCancel={() => {
                  setEditRemark({ visible: false })
                }}
              />
            </div>
            {!editRemark.visible && (
              <IconFont
                type="icon-huabanfuben"
                style={{
                  color: '#999',
                  cursor: 'pointer',
                  marginLeft: 5,
                  marginRight: 5,
                }}
                onClick={() => {
                  setEditRemark({
                    visible: true,
                  })
                }}
              />
            )}
          </>
        </SignTitle>
      }
      open={showLog.visible}
      onCancel={() => setShowLog({ visible: false, id: null })}
      footer={null}
    >
      <Table columns={columns} dataSource={logList?.records} pagination={false} />
      <div
        style={{
          justifyContent: 'flex-end',
          marginTop: '10px',
          display: logList?.records?.length > 0 ? 'flex' : 'none',
        }}
      >
        <Pagination
          current={pageParams.page}
          pageSize={pageParams.limit}
          pageSizeOptions={['10', '20', '50', '100']}
          total={logList?.total}
          showTotal={total => <ShowTotal>{total}</ShowTotal>}
          showSizeChanger
          showQuickJumper
          onChange={(page, pageSize) => {
            setPageParams({
              page,
              limit: pageSize,
            })
          }}
        />
      </div>
      <DeleteModal
        text={t('此客户端将永久删除，是否继续?')}
        visible={deleteModal.visible}
        onOk={async () => {
          try {
            // await deleteLog({ id: deleteModal.id })
            // await getLogList()
          } catch (error) {}
          setDeleteModal({
            visible: false,
            id: null,
          })
        }}
        onCancel={() =>
          setDeleteModal({
            visible: false,
            id: null,
          })
        }
      />
    </LogModal>
  )
}

const LogModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 4px;
  }
  .ant-modal-body {
    position: relative;
    padding-top: 20px;
  }
  .title {
    position: absolute;
    top: 15px;
    left: 33px;
  }
  .operate {
    display: flex;
  }
  .icon {
    width: 16px;
    height: 16px;
    background: none;
    margin-right: 0;
  }
`
